import { ColumnDef } from '@tanstack/react-table';
import { BuslineQueryData } from '@area-restrita/api-client/model/buslineQueryData';

import BuslineActionsCell from './BuslineActionsCell';
import ChecklistCell from './ChecklistCell';
import { getChecklistDisplay } from './getChecklistDisplay';

export const columns: ColumnDef<BuslineQueryData>[] = [
  {
    id: 'search',
    meta: { className: 'hidden' },
  },
  { id: 'code', accessorKey: 'code', header: 'Código' },
  { id: 'name', accessorKey: 'name', header: 'Nome' },
  {
    id: 'prefix',
    accessorKey: 'fleet',
    header: 'Prefixo',
    accessorFn: ({ fleet }) => fleet?.prefix ?? 'N/A',
  },
  {
    id: 'companyIds',
    accessorKey: 'company',
    header: 'Empresa',
    accessorFn: ({ company }) => company.tradingName,
  },
  {
    id: 'checklist',
    header: 'Checklist',
    accessorFn: (busline) => getChecklistDisplay(busline).label,
    cell: ChecklistCell,
  },
  {
    header: 'Ações',
    meta: { className: 'text-right z-10', onClick: (e) => e.stopPropagation() },
    cell: BuslineActionsCell,
  },
];
